<style lang="scss" scoped>
.sidebar-wrapper {
  position: relative;
  margin-left: 0.65rem;
  margin-top: 2.1rem;
}

.sidebar {
  position: absolute;
  width: max-content;
  overflow-y: auto;
  z-index: 20;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>

<script>
import menuItemIcon from "@c/menu-item-icon.vue";
import menuItem from "@c/menu-item.vue";
export default {
  components: { menuItem, menuItemIcon },
  data() {
    return {};
  },
  computed: {},
};
</script>

<template>
  <div class="sidebar-wrapper">
    <div class="sidebar">
      <nav class="dashboard-content--nav">
        <!-- <menu-item-icon href="/organization" icon="iconoir-dashboard-speed" :name="$t('organization.panel')" /> -->
        <menu-item-icon href="/organization/settings" icon="iconoir-settings" :name="$t('organization.settings')" />
        <menu-item-icon href="/organization/members" icon="iconoir-user-circle" :name="$t('organization.members.text')" />
        <menu-item-icon href="/organization/announcement" icon="bx bx bxs-megaphone" :name="$t('announcement.plural')" />
        <!-- <menu-item-icon href="/organization/file-manager" icon="iconoir-submit-document" :name="$t('file-manager.text')" /> -->
        <hr />
        <menu-item-icon href="/" tag="a" icon="iconoir-view-grid" :name="$t('dashboard.text')" />

        <menu-item
          v-if="hasCurrentOrganizationAccessable('FWSED')"
          href="/fwsed/dashboard"
          tag="a"
          image="/icons/fwsed.svg"
          imageActive="/icons/fwsed-active.svg"
          :name="$t('product.fwsed.product')"
        />
      </nav>
    </div>
  </div>
</template>
